var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InfoIconWrapper',{attrs:{"show-info-icon":_vm.showInfoIcon,"content":_vm.content,"model":_vm.model,"align-top":_vm.alignTop,"inline-element":_vm.inlineElement}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }